import React, { useState } from 'react';
import EyeOff from "../../../../../Assets/eyeIconOff.svg";
import Eye from "../../../../../Assets/eye.svg";

function PasswordInput({ title, errorText, inputOptions }) {
    const [inputType, setInputType] = useState('text');

    function handleChangeInputType() {
        if(inputType === 'text') {
            setInputType('password');
        }
        else {
            setInputType('text');
        }
    }

    return (
        <div className='flex flex-col gap-2'>
            <div className="flex items-center justify-between">
                <label htmlFor={inputOptions.name} className='font-medium text-base text-[#121212]'>{title}</label>

                {errorText && <p className='text-[12px] leading-5 text-[#EF4444]'>{errorText}</p>}
            </div>

            <div className="border border-[#EAEAEA] bg-[#F5F5F5] px-3 py-4 rounded-lg flex items-center gap-[10px]">
                <input 
                    type={inputType} 
                    className='w-[calc(100%-24px)] bg-transparent outline-none font-normal text-base text-[#121212] placeholder:text-[#666666]' 
                    placeholder='enter password' 
                    {...inputOptions} 
                />

                <button onClick={handleChangeInputType} className="outline-none size-6 flex items-center justify-center">
                    <img src={inputType === 'text' ? Eye : EyeOff} alt="" />
                </button>
            </div>
        </div>
    );
}

export default PasswordInput;
